import { useEffect, useState } from "react";
import {
  Box,
  Textarea,
  Input,
  Button,
  Select,
  Stack,
  Flex,
  Text,
  Grid,
  GridItem,
  FormControl,
  FormLabel,
  useToast,
  useDisclosure,
} from "@chakra-ui/react";
import Notification from "../../services/Notification";
import { useNavigate } from "react-router-dom";

import ImageUploadModal from "../Modals/ImageUploadModal";
import TestModal from "../Modals/TestModal";

const EmailTemplate = ({
  emailVariables,
  setId,
  setNotificationId,
  notificationId,
  userId,
  appUserId,
  pageId,
  variableValues,
  setVariableValues,
}: any) => {
  const token = localStorage.getItem("logged_in_user_token");
  // const [data, setData] = useState([]);
  const toast = useToast();
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [modal, setModal] = useState("");

  const [email, setEmail] = useState<any>([]);
  const [selectedEmail, setSelectedEmail] = useState<any>(null);

  const [variableCount, setVariableCount] = useState(
    selectedEmail?.variable_count ?? 0
  );

  const [selectedKeys, setSelectedKeys] = useState(
    Array(variableCount).fill("")
  );

  const [selectedValues, setSelectedValues] = useState(
    Array(variableCount).fill("")
  );

  const [imageValue, setImageValue] = useState("");
  const [linkValue, setLinkValue] = useState("");


  // const [variableValues, setVariableValues] = useState<
  //   { key: string; value: string }[]
  // >([]);


  const fetchData = async () => {
    await Notification.getEmailTemplates("1", "10", "dolphin")
      .then((res) => {
        // setData(res.data);
        setEmail(res.data.data);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
        console.log(error);
      });
  };

  const handleKeyChange = (index: number, value: string) => {
    const newKeys = [...selectedKeys];
    newKeys[index] = value;
    setSelectedKeys(newKeys);
  };

  const handleValueChange = (index: number, value: string) => {
    const newValues = [...selectedValues];
    newValues[index] = value;
    setSelectedValues(newValues);
  };

  const handleEmailChange = (event: any) => {
    const emailName = event.target.value;
    const selectedItem = email.find(
      (item: any) => item.template_name === emailName
    );

    setSelectedEmail(selectedItem || null);
    setVariableCount(selectedItem?.variable_count ?? 0);
    setNotificationId(selectedItem?._id);
    setId(selectedItem?._id);
  };

  const handleSend = async () => {
    await Notification.updateEmailTemplate(
      notificationId,
      variableValues
    ).then((res) => {
      console.log(res.data);
    });

    await Notification.sendDolphinActionNotification(
      "email",
      notificationId,
      userId,
      appUserId
    ).then((res) => {
      toast({
        position: "top",
        title: "Email Sent.",
        description: "Email is sent to the user successfully.",
        status: "success",
        duration: 1000,
        isClosable: true,
      });
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const updatedSelectedValues = selectedKeys.map((key) => {
      if (key === "image") return imageValue;
      if (key === "link") return linkValue;
      return key && emailVariables[key] !== undefined
        ? Array.isArray(emailVariables[key])
          ? emailVariables[key].join(", ")
          : emailVariables[key]
        : ""; // empty string instead of undefined
    });

    setSelectedValues(updatedSelectedValues);

    setVariableValues(
      selectedKeys.map((key, index) => ({
        key,
        value:
          key === "link" || key === "image" ? updatedSelectedValues[index] : "",
      }))
    );
  }, [selectedKeys, emailVariables, imageValue, linkValue]);

  useEffect(() => {
    setSelectedKeys(Array(variableCount).fill(""));
    setSelectedValues(Array(variableCount).fill(""));
  }, [variableCount]);

  return (
    <Box bg="gray.100" p={6}>
      <Grid templateColumns="repeat(3, 1fr)" gap={2}>
        <GridItem bg="#f6ffff" colSpan={2}>
          <Box p={3} bg="#518585" color="white">
            {selectedEmail?.template_name}
          </Box>

          <Text p={2}>Subject: {selectedEmail?.subject}</Text>

          <Textarea
            h="300px"
            border="0px"
            placeholder="Dear: ..."
            defaultValue={selectedEmail?.body || ""}
            p={2}
          />
          {/* </Box> */}
          {!["leads-reachout", "customer-reachout"].includes(pageId) && (
            <Flex p={2} align="center" gap={8}>
              <Button
                colorScheme="yellow"
                size="sm"
                onClick={() => handleSend()}
              >
                SEND
              </Button>
              <Button
                colorScheme="yellow"
                size="sm"
                onClick={() => {
                  setModal("testModal");
                  onOpen();
                }}
              >
                SEND TO TEST USER
              </Button>
              {modal === "testModal" && (
                <TestModal
                  isOpen={isOpen}
                  onClose={onClose}
                  templateId={notificationId}
                  emailVariables={variableValues}
                  type="email"
                />
              )}
            </Flex>
          )}
        </GridItem>

        <GridItem p={6} gap={2}>
          {/* <Box w="35%" p={6} ml={4}> */}
          <Stack spacing={8}>
            <FormControl>
              <FormLabel fontSize="lg" fontWeight="semibold">
                Choose Template
              </FormLabel>
              <Select
                placeholder="Select"
                value={selectedEmail?.template_name}
                onChange={handleEmailChange}
              >
                {email.map((item: any, index: any) => (
                  <option key={index} value={item.template_name}>
                    {item.template_name}
                  </option>
                ))}
              </Select>
            </FormControl>
            {selectedEmail && (
              <FormControl>
                <FormLabel fontSize="lg" fontWeight="semibold">
                  Choose Variables
                </FormLabel>
                <Flex direction="column" gap={4}>
                  {Array.from({ length: variableCount }).map((_, index) => (
                    <Flex
                      key={index}
                      justifyContent="center"
                      alignItems="center"
                      gap="4"
                    >
                      <Text fontWeight="medium" fontSize="20px">
                        [{index + 1}]
                      </Text>
                      <Select
                        placeholder="Select"
                        value={selectedKeys[index]}
                        onChange={(e) => {
                          handleKeyChange(index, e.target.value);
                          if (e.target.value === "image") {
                            setModal("imageUpload");
                            onOpen();
                          }
                        }}
                      >
                        {Object.keys(emailVariables).map((item) => (
                          <option key={item} value={item}>
                            {item}
                          </option>
                        ))}
                        {index === 0 && <option value="image">Image</option>}
                        <option value="link">Link</option>
                      </Select>
                      {modal === "imageUpload" && (
                        <ImageUploadModal
                          isOpen={isOpen}
                          onClose={onClose}
                          setImageValue={setImageValue}
                        />
                      )}

                      {(selectedKeys[index] === "link" ||
                        selectedKeys[index] === "image" ||
                        !["leads-reachout", "customer-reachout"].includes(
                          pageId
                        )) && (
                        <Input
                          onChange={(e) => {
                            if (selectedKeys[index] === "link") {
                              setLinkValue(e.target.value);
                            } else {
                              handleValueChange(index, e.target.value);
                            }
                          }}
                          type="text"
                          paddingLeft={2}
                          bg="white"
                          id="variable"
                          name="variable"
                          placeholder=""
                          value={
                            selectedKeys[index] === "link"
                              ? linkValue || ""
                              : Array.isArray(selectedValues[index]) &&
                                selectedValues[index].every((val: any) => !val)
                              ? "Not Known"
                              : selectedValues[index] || "Not Known"
                          }
                          // disabled={true}
                          isDisabled={
                            selectedKeys[index] === "link" ? false : true
                          }
                        />
                      )}
                    </Flex>
                  ))}
                </Flex>
              </FormControl>
            )}
          </Stack>
        </GridItem>
      </Grid>
    </Box>
  );
};

export default EmailTemplate;
